$('#offices').on('shown.bs.collapse', function () {
    $('#officeSelectorToggle').find('span').toggleClass('d-inline-block');
});
$('#offices').on('hidden.bs.collapse', function () {
    $('#officeSelectorToggle').find('span').toggleClass('d-inline-block');
});
